export default "__VITE_ASSET__D9FWK$Xr__"